import type { CarlineQuery } from '../../@types/mapped';

export const getConfigureUrl = ({ links }: CarlineQuery) =>
  links?.shopTheLookPage?.url && links?.shopTheLookPage?.url.trim() !== ''
    ? links?.shopTheLookPage?.url
    : links?.configuratorPage?.url;
